import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { createPersologElementButton_CreatePersologElementMutation } from "@relay/createPersologElementButton_CreatePersologElementMutation.graphql";
import { CREATE_PERSOLOG_ELEMENT_MUTATION } from "./create-persolog-element-button.graphql";
import { CreatePersologElementButtonProps } from "./create-persolog-element-button.types";
import { persologClasses } from "../persolog-element-form/persolog-element-form.consts";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const CreatePersologElementButton = ({
	eLearningContentNodeId,
}: CreatePersologElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createPersologElement, isCreatingPersologElement] =
		useMutation<createPersologElementButton_CreatePersologElementMutation>(
			CREATE_PERSOLOG_ELEMENT_MUTATION,
		);

	const handleCreatePersologElement = () => {
		createPersologElement({
			variables: {
				input: {
					title: t("educationalOffer.newPersologElement"),
					eLearningContentId: eLearningContentNodeId,
					classes: persologClasses.map((persologClass) => ({
						title: persologClass.title,
						text: persologClass.text,
						classType: persologClass.classType,
						imageId: undefined,
					})),
				},
			},
			updater: setDraft,
		});
	};

	return (
		<Button
			disabled={isCreatingPersologElement}
			tooltip={t("educationalOffer.createPersologElementTooltip")}
			icon={EpicIcons.USER}
			onClick={handleCreatePersologElement}
		/>
	);
};
